module.exports = __webpack_public_path__ + "static/user2-181890da7459bae6c23454cf7121ed65.jpg";